import { OlympusClient } from '@/OlympusClient'

export const deleteBlockHandler = async (blockId: string): Promise<void> => {
  await OlympusClient.funnel.v1.sections.section.deleteSection({
    params: { sectionId: blockId },
  })
}
